import React from "react";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import CssBaseline from "@material-ui/core/CssBaseline";
import { defaultTheme } from "./src/styles/theme";

export const wrapRootElement = ({ element }) => (
  <MuiThemeProvider theme={defaultTheme}>
    <StyledThemeProvider theme={defaultTheme}>
      <CssBaseline />
      {element}
    </StyledThemeProvider>
  </MuiThemeProvider>
);